export class Options {
  pollms: number = 0;
  pageSize: number = 0;
  queryOnLoad: boolean = true;
  paginated: boolean = true;

  isAdmin: boolean = false;

  allowEditing: boolean = false;
  allowImpersonation: boolean = false;
  allowFavorites: boolean = false;

  selectAction: string = '';
  restrictToAction: number = 0;
  selectRoute: string = '';

  filterable: boolean = false;
  userId: string | undefined = '';
  accountId: string | undefined = '';
  merchantId: string = '';
  customerId: string = '';
  orderId: string = '';
  invoiceNumber: string = '';

  month: string = '';
  year: string = '';

  hiddenFields: string[] | undefined = [];

  restrictToMyMerchants = true;

  invoiceStatus: string | undefined = '';

  debug: string = '';

  public constructor(options: Partial<Options>) {
    this.pollms = options.pollms || 0;
    this.pageSize = options.pageSize || 0;
    this.queryOnLoad = options.queryOnLoad || true;
    this.isAdmin = options.isAdmin || false;
    this.allowEditing = options.allowEditing || false;
    this.allowImpersonation = options.allowImpersonation || false;
    this.allowFavorites = options.allowFavorites || false;
    this.selectAction = options.selectAction || '';
    this.restrictToAction = options.restrictToAction || 0;
    this.userId = options.userId || '';
    this.accountId = options.accountId || '';
    this.merchantId = options.merchantId || '';
    this.customerId = options.customerId || '';
    this.month = options.month || '';
    this.year = options.year || '';
    this.hiddenFields = options.hiddenFields || [];
    this.restrictToMyMerchants = options.restrictToMyMerchants || true;
    this.filterable = options.filterable || false;
    this.debug = options.debug || '';
    this.selectRoute = options.selectRoute || '';
    this.paginated = options.paginated || true;
    this.pollms = options.pollms || 0;
    this.userId = options.userId || '';
    this.invoiceStatus = options.invoiceStatus || '';
    this.orderId = options.orderId || '';
    this.invoiceNumber = options.invoiceNumber || '';
  }
}
